<template>
  <div id="WatchList">
    <div class="list_slide_box">
      <div class="watch_checkbox_box">
        <el-checkbox class="watch_checkbox_all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
        <div class="watch_delete" :class="checkedCities.length>0?'on':''" @click="WatchDelete()">{{$t('base.delete')}}</div>
      </div>
      <div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <div class="watch_box_list" v-for="(item,index) in list" :key="index">
            <el-checkbox class="watch_checkbox watch_el" :label="item">
            </el-checkbox>
            <div class="watch_checkbox">
              <div class="watch_box_flex">
                <div class="watch_box">
                  <router-link :to="{path:'/carddetails/'+item.ID}">
                    <div class="like_box">
                      <el-image class="like_img" :src="item.TitImg!='没有可上传的图片'?item.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
                      <!-- watch -->
                      <span class="favorite sold" v-if='item.Status<0'>{{$t('base.soldOut')}}</span>
                      <span class="favorite" v-if="type=='watch'&&item.IsOutBid=='2'&&item.Status==1">{{$t('base.outBid')}}</span>
                      <span class="favorite black" v-if="type=='watch'&&item.EffectiveDate=='Ended listing'">{{$t('base.ended')}}</span>
                      <!--  <span v-if="type=='watch'&&(item.Status==0||item.Status==-2)" class="favorite black">ENDED{{item.Status}}</span> -->
                      <span v-if="index==0&&type=='offers'" class="favorite">{{$t('base.offerReceived')}}</span>
                      <span v-if="index==1&&type=='offers'" class="favorite greed">{{$t('base.offerSent')}}</span>
                      <span v-if="index==2&&type=='offers'" class="favorite gray">{{$t('base.offerDeclined')}}</span>
                      <span v-if="index==3&&type=='offers'" class="favorite gray">{{$t('base.offerExpired')}}</span>
                      <span v-if="index==4&&type=='offers'" class="favorite black">{{$t('base.offerClosed')}}</span>
                    </div>
                  </router-link>
                </div>
                <div class="watch_title_box">
                  <div class="watching_height">
                    <h4 class="line_txt3">
                      <router-link :to="{path:'/carddetails/'+item.ID}" :class="{'global':item.SellMemberSource!=userInfo.MemberSource}">{{item.Title}}</router-link>
                    </h4>
                    <span>( {{item.CommodityCode}} )</span>
                  </div>
                  <div class="watching_height2" v-if="type=='watch'">
                    <div>SELLER:</div>
                    <div class="bids">
                      <router-link tag='em' :to="{path:'/seller/detail/'+item.ReceiveUserID}">{{item.RealName}} ({{item.BuyFavorableCount+item.SellFavorableCount}})</router-link>
                      <!-- <router-link tag='em' :to="{path:'/seller/detail/'+item.ReceiveUserID}">{{item.RealName}} ({{item.BuyFavorableCount}})</router-link> -->
                    </div>
                    <div>{{item|setFeedback}} {{$t('base.positive')}}</div>
                  </div>
                  <div class="watching_height3" v-if="type=='watch'">
                    <span class="span_watch_bg ending" v-if="CountDown(item.EffectiveDate)==1&&item.Status==1">{{$t('enum.endingSoon')}}{{CountDown(item.EffectiveDate)}}</span>
                    <span class="span_watch_bg">{{item.AttentionCount}} {{$t('base.watching')}}</span>
                  </div>
                  <div class="watching_height2" v-if="type=='offers'||type=='nowin'">
                    <div class="bids">1Cardwizard</div>
                    <div class="bids">98765</div>
                    <div>99.9%</div>
                  </div>
                </div>
                <div class="watch_price_box" v-if="type=='watch'">
                  <div class="watching_height watch_bids">
                    <!-- <div v-if="index==0" class="price_us text_red">$ {{item.USD_Price}}</div>
                    <div v-if="index==1" class="price_us text_greed">$ {{item.USD_Price}}</div> -->
                    <div class="price_us" v-if="item.Status>0" :class="item.IsOutBid==2?'text_red':(item.IsOutBid==3?'text_greed':'')">{{areaSymbol}} {{item.USD_Price}}</div>
                    <div class="price_us" v-else  :class="item.IsOutBid==3?'text_greed':''">{{areaSymbol}} {{item.USD_Price}}</div>
                    <router-link v-if="item.ByWay==2" class="bids" :to="{path:'/mycardhobby/bidhistory/'+item.ID}">{{item.AuctionCount}} {{item.AuctionCount!=1?$t('base.bids'):$t('base.bid')}}</router-link>
                    <span>{{ifNaN(item.USD_PostageMoney)}}</span>
                    <!-- <span class="">{{item.PostageMoney!=0?'+'+item.PostageMoney+' Shipping':'Free Shipping'}}</span> -->
                  </div>
                  <div class="watching_height2">
                    <div class="time_end">{{$t('base.timeEnds')}}</div>
                    <div>{{item.EffectiveDate|setTime}}</div>
                    <!-- <div class="time_end">Sunday 11, 2022 07:30 PDT</div> -->
                  </div>
                </div>
                <div class="" v-if="type=='offers'">
                  <div class="watching_height watch_bids">
                    <div class="price_us">{{areaSymbol}} {{item.num}}</div>
                    <span>Your offer</span>
                    <div class="price_us no_us">{{areaSymbol}} {{item.num}}</div>
                    <span>Original Price</span>
                    <span>+ shipping</span>
                  </div>
                  <div class="watching_height2">
                    <div class="time_end">Offer expires in</div>
                    <!-- <div :class="CountDown(item.time)|day">{{ CountDown(item.time) }}</div> -->
                    <div class="time_end">Sunday 11, 2022 07:30 PDT</div>
                  </div>
                </div>
                <div class="" v-if="type=='nowin'">
                  <div class="watching_height watch_bids">
                    <div class="price_us">{{areaSymbol}} {{item.num}}</div>
                    <span class="bids">10 bids</span>
                  </div>
                  <div class="watching_height2">
                    <!-- <div :class="CountDown(item.time)|day">{{ CountDown(item.time) }}</div> -->
                    <div class="time_end">Sunday 11, 2022 07:30 PDT</div>
                  </div>
                </div>
                <div class="watch_box_btn" v-if="type=='watch'&&item.ReceiveUserID!=userInfo.MappingUserId">
                  <div v-if="item.ByWay==2&&CountDown(item.EffectiveDate)==0">
                    <div @click='getAuctionCheck(item)' v-if="userInfo.Count>0">{{item.IsOutBid==2?$t('base.maxBid'):$t('base.bidNow')}}</div>
                    <div @click="isAddCout" v-else>{{item.IsOutBid==2?$t('base.maxBid'):$t('base.bidNow')}}</div>
                  </div>
                  <div v-if="item.ByWay==1&&CountDown(item.EffectiveDate)==0" @click="BuyItNow(item)">{{$t('base.buyNow')}}
                  </div>
                  <!-- <div @click="getMakeOffer(item)" v-if="item.ByWay==1&&item.Bargain==1&&CountDown(item.EffectiveDate)==0&&userInfo.Count>0">Make Offer</div> -->
                  <div  v-if="item.ByWay==1&&item.Bargain==1&&CountDown(item.EffectiveDate)==0&&userInfo.Count>0">
                    <router-link :to="{path:'/mycardhobby/offerhistory/'+item.ID}">{{$t('base.offerHistory')}}</router-link>
                  </div>
                  <div @click="isAddCout" v-if="item.ByWay==1&&item.Bargain==1&&CountDown(item.EffectiveDate)==0&&userInfo.Count<=0">{{$t('base.offerHistory')}}</div>
                  <div>
                    <router-link :to="{path:'/seller/detail/'+item.ReceiveUserID}">{{$t('base.visitStore')}}</router-link>
                  </div>
                  <div class="ContactSeller" @click="allContact(item.ReceiveUserID,item.ID)">{{$t('base.contactSeller')}}</div>
                  <!-- <div>
                    <router-link :to="{path:'/terms/customer',query:{item:JSON.stringify(item),seller:item.RealName,sellerid:item.ReceiveUserID}}">Contact Seller111</router-link>
                  </div> -->
                </div>
                <div class="watch_box_btn" v-if="type=='watch'&&item.ReceiveUserID==userInfo.MappingUserId">
                  <div v-if="item.ByWay==2&&CountDown(item.EffectiveDate)==0" class="error">
                    <div class="error" v-if="userInfo.Count>0">{{item.IsOutBid==2?$t('base.maxBid'):$t('base.bidNow')}}</div>
                    <div class="error" v-else>{{item.IsOutBid==2?$t('base.maxBid'):$t('base.bidNow')}}</div>
                  </div>
                  <div class="error" v-if="item.ByWay==1&&CountDown(item.EffectiveDate)==0">{{$t('base.buyNow')}}
                  </div>
                  <div class="error" v-if="item.ByWay==1&&item.Bargain==1&&CountDown(item.EffectiveDate)==0&&userInfo.Count>0">{{$t('base.offerHistory')}}</div>
                  <div class="error" v-if="item.ByWay==1&&item.Bargain==1&&CountDown(item.EffectiveDate)==0&&userInfo.Count<=0">{{$t('base.offerHistory')}}</div>
                  <div>
                    <router-link :to="{path:'/seller/detail/'+item.ReceiveUserID}">{{$t('base.visitStore')}}</router-link>
                  </div>
                  <div class="ContactSeller" @click="allContact(item.ReceiveUserID,item.ID)">{{$t('base.contactSeller')}}</div>
                  <!-- <div>
                    <router-link :to="{path:'/terms/customer',query:{item:JSON.stringify(item),seller:item.RealName,sellerid:item.ReceiveUserID}}">Contact Seller111</router-link>
                  </div> -->
                </div>
                <div class="watch_box_btn" v-if="type=='offers'">
                  <div>{{$t('base.viewOfferDetails')}}</div>
                  <div>
                    <router-link :to="{path:'/seller/detail/1'}">{{$t('base.visitStore')}}</router-link>
                  </div>
                  <div>
                    <router-link :to="{path:'/buynow/2?type=c'}">{{$t('base.buyNow')}}</router-link>
                  </div>
                  <div>
                    <router-link :to="{path:'/terms/customer',query:{item:''}}">{{$t('base.contactSeller')}}</router-link>
                  </div>
                </div>
                <div class="watch_box_btn" v-if="type=='nowin'">
                  <div>
                    <router-link :to="{path:'/seller/detail/1'}">{{$t('base.visitStore')}}</router-link>
                  </div>
                  <div>
                    <router-link :to="{path:'/terms/customer',query:{item:''}}">{{$t('base.contactSeller')}}</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <!-- el-dialog -->
    <place-bid v-if="placeVisible" :Visible="placeVisible" @getDialog="getPlace" :list="PlaceList" :Auction='isAuction' :time="EffectiveDate" />
    <!-- <make-offer :makeVisible="makeVisible" @getDialog="getDialog" :list="PlaceList" /> -->
  </div>
</template>
<script>
import MakeOffer from "@/components/dialog/makeoffer";
import PlaceBid from "@/components/dialog/placebid";
import { countDown, getInfo, getTime, setUTC, GoYunXin, isNumber } from "@/api/public";
import qs from 'qs'
export default {
  name: 'watchlistcheck',
  components: { MakeOffer, PlaceBid },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      userInfo: '',
      EffectiveDate: '',
      dialogVisible: false,
      makeVisible: false,
      placeVisible: false,
      isAuction: false,
      PlaceList: null,
      timer: "",
      nowData: new Date().getTime(),
      checkAll: false,
      checkedCities: [],
      cities: this.list,
      isIndeterminate: false,
    }
  },
  props: {
    list: {},
    type: String
  },
  filters: {
    day(val) {
      if (val.indexOf('00:00') != -1) {
        return 'text_red'
      } else if (val.indexOf('D') != -1) {
        var num = val.indexOf('D')
        if (num <= 1) {
          return 'text_greed'
        }
        return 'text_red'
      }
    },
    setFeedback(val) {
      var FavorableCount=(val.BuyFavorableCount+val.SellFavorableCount)
      var TotalCount=(val.BuyFavorableCount + val.SellFavorableCount + val.BuyNegativeCount+val.SellNegativeCount)
      let data = ((FavorableCount / TotalCount) * 100)
      if (TotalCount > 0) {
        if (data != 100) {
          data = data.toFixed(2)
        }
      } else {
        data = 100
      }
      return data + '%'
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
  },
  created() {
    this.userInfo = getInfo();
    this.cardTimer();
  },
  methods: {
    ifNaN(val) {
      if(Number(val).toString()!='NaN'){
        val='$ '+val + this.$t('base.shipping')
      }
      return val;
    },
    allContact(val,oid) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val,oid,1000)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    isAddCout() {
      this.$confirm('You have not set your shipping address!', 'Something Important', {
        confirmButtonText: 'Go to Set',
        cancelButtonText: 'Cancel',
        lockScroll: false
      }).then(() => {
        let url = this.$router.resolve({ path: '/mycardhoddy/setting' })
        window.open(url.href, '_blank');
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
    },
    //竞拍资格校验
    getAuctionCheck(val) {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': val.ID }
      //console.log(val, 'val')
      that.PlaceList = val;
      that.EffectiveDate = val.EffectiveDate
      this.$get(this.$interface.AuctionCheck, data).then(res => {
        //that.isread=false;
        if (res.result != 0) {
          that.PlaceList = val;
          that.EffectiveDate = val.EffectiveDate
          that.isAuction = true;
          that.placeVisible = true;
        } else {
          that.PlaceList.DepositNum = res.data.DepositNum;
          that.PlaceList.SumMoney = res.data.SumMoney;
          that.isAuction = false;
          that.placeVisible = true;
        }
        //this.getPrice()
        // msg: '竞拍校验通过', result: 1
      })
    },
    getMakeOffer(val) {
      let that = this
      that.PlaceList = val;
      that.makeVisible = true;
    },
    BuyItNow(val) {
      let data = {
        "HeadPortrait": "https://bucket-katao.oss-cn-hangzhou.aliyuncs.com/touxiang.png",
        "SellRealName": val.RealName,
        "BuyerWyAccId": this.userInfo.MappingUserId,
        "SellerWyAccId": val.ReceiveUserID,
        "Details": [{
          "ID": val.ID,
          "Title": val.Title,
          "TitImg": val.TitImg,
          "USD_Price": val.USD_Price,
        }],
        "USD_PostageMoney": '0',
        "USD_TotalPrice": val.USD_Price
      }
      window.sessionStorage.setItem('check', JSON.stringify(data))
      this.$router.push({
        path: '/pay/checkout/'
      })
    },
    getDialog(val, id) {
      this.makeVisible = val;

    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    handleCheckAllChange(val) {
      //console.log(val,this.list)
      this.checkedCities = val ? this.list : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      //console.log(value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      //console.log(this.isIndeterminate)
    },
    getPlace(val, val1) {
      this.placeVisible = val;
      this.PlaceList = null;
      this.EffectiveDate = '';
      this.isAuction = false;
      if (val1) {
        this.$emit('updatedWatch', 'watch')
      }
    },
    WatchDelete() {
      if (this.checkedCities.length > 0) {
        let that = this;
        if (that.type == "watch") {
          let watchDetail = this.checkedCities;
          let ids = []
          watchDetail.map(res => {
            ids.push(res.ID)
          })
          let data = { attentionType: 2, ids: ids, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, operator_id: that.userInfo.MappingUserId }
          this.$post(this.$interface.CancelAttention, qs.stringify(data)).then(res => {
            //console.log(res)
            if (res.result != 0) {
              this.$emit('updatedWatch', 'watch')
            }
          })
        }
        //console.log(this.checkedCities, 'checkedCities')
        //     let data = { 'selluserid': val, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        // this.$post(this.$interface.SetAttention, qs.stringify(data)).then(res => {
        //   console.log(res)
        //   if (res.result != 0) {
        //     this.$emit('updatedWatch')
        //   }

        // })
        // this.$confirm('Are you sure that you want to permanently clear all Recently viewed items?', 'Confirm to clear all', {
        //   confirmButtonText: 'Confirm',
        //   cancelButtonText: 'Cancel',
        // }).then(() => {
        //   // this.$message({
        //   //   type: 'success',
        //   //   message: '删除成功!'
        //   // });
        // }).catch(() => {
        //   // this.$message({
        //   //   type: 'info',
        //   //   message: '已取消删除'
        //   // });          
        // });
        //console.log(this.checkedCities)
      }
    }
  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "../../../static/css/watchlist.css";

.el-checkbox {
  color: #333;
}

.watch_box_list {
  display: flex;
}

.watch_checkbox {
  width: 96%;
}

.watch_el {
  width: 4%;
  margin-top: 98px;
}

.watch_el .el-checkbox__label {
  display: none;
}

.watch_checkbox .el-checkbox__input {
  margin-top: 0;
}

.watch_checkbox_all .el-checkbox__input {
  margin-top: 7px;
}

.watch_checkbox_box {
  display: flex;
  padding: 22px 0 12px;
  border-bottom: 1px solid #f0f0f0;
}

.watch_box_flex {
  display: flex;
  white-space: normal;
  justify-content: space-between;
}

.watch_delete {
  font-size: 14px;
  border: 1px solid #333;
  /* font-weight: bold; */
  border-radius: 4px;
  height: 32px;
  width: 80px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  margin-left: 22px;
}

.watch_delete.on {
  border-color: #5F6DAE;
  color: #5F6DAE
}

.ContactSeller {
  cursor: pointer;
}
.global{
}
.global:before{
  float: left;
  content: '';
  background: url(/static/images/icon/icon_earth.svg) no-repeat 0 50%;
  width: 16px;
  height: 24px;
  margin-right: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/list/watchcheck.vue